/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-30 16:59:24
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-07-01 14:43:13
 * @FilePath: /zeelool-nextjs/src/app/payment/components/WorryFreeDelivery/components/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Currency } from '@/api/types/public';
import Dialog from '@/components/Dialog';
import Image from '@/components/Image';
import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { CloseOutlined } from '@zeelool/icon';
import styles from './style.module.scss';
import { useTranslations } from 'next-intl';

interface WorryFreeDeliveryDialogProps {
  open: boolean;
  onClose: () => void;
  insurancePrice?: string;
  currency?: Currency;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export default function WorryFreeDeliveryDialog({
  open,
  onClose,
  insurancePrice,
  currency,
  onConfirm,
  onCancel,
}: WorryFreeDeliveryDialogProps) {
  const t = useTranslations('payment.WorryFreeDelivery');
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    onClose();
  };

  const renderTitle = () => {
    return (
      <div className="flex items-center justify-center flex-nowrap relative">
        <Image src="/payment/Seel_Icon.png" alt="" width={31} height={24} className="mr-8" />
        <span className="font-bb text-18 whitespace-nowrap"> {t('worryFreeDelivery')} &nbsp;</span>
        <span className="font-br whitespace-nowrap">
          for <span>{formatPriceNumberWithSymbol(insurancePrice, currency)}</span>
        </span>

        <WapOnly>
          <CloseOutlined
            className="text-24 absolute -right-20 -top-20 cursor-pointer"
            onClick={onClose}
          />
        </WapOnly>
      </div>
    );
  };

  return (
    <>
      <WebOnly>
        <Dialog open={open} title={renderTitle()} onClose={onClose} footer={null}>
          <div className="box-dialog-inner">
            <section className={styles.content}>
              <div className={styles.inner}>
                <div className={styles.highlight}>{t('whatsCoveredBySeel')}</div>
                <div className={styles.special}>
                  <div>{t('getFullRefund')}</div>
                  <ul>
                    <li>
                      <Image src="/payment/icon-yes.png" alt="" width={16} height={16} />{' '}
                      {t('lostInTransit')}
                    </li>
                    <li>
                      <Image src="/payment/icon-yes.png" alt="" width={16} height={16} />{' '}
                      {t('itemDamagedInTransit')}
                    </li>
                    <li>
                      <Image src="/payment/icon-yes.png" alt="" width={16} height={16} />{' '}
                      {t('packageStolenOrMissing')}
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.inner}>
                <div className={styles.highlight}>{t('easyResolution')}</div>
                <div className={styles.normalTxt}>{t('resolveIssuesWithFewClicks')}</div>
              </div>
              <div className={styles.inner}>
                <div className={styles.highlight}>{t('completePeaceOfMind')}</div>
                <div className={styles.listTxt}>
                  <ul>
                    <li className={styles.normalTxt}>{t('zeroRiskWithProtection')}</li>
                    <li className={styles.normalTxt}>{t('getRefundPromptly')}</li>
                  </ul>
                </div>
              </div>
            </section>
            <section className={styles.btnSection}>
              <div className={`${styles.btn} px-24`} onClick={handleConfirm}>
                {t('optInNowForFullProtection')}
              </div>
              <div className={styles.noNeed} onClick={handleCancel}>
                {t('noNeed')}
              </div>
            </section>
            <section className={styles.footer}>
              <a href="https://www.seel.com/privacy" target="_blank" rel="noopener noreferrer">
                {t('privacyPolicy')}
              </a>
              <a
                href="https://www.seel.com/terms/worry-free-delivery-for-customer"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('termsOfService')}
              </a>
            </section>
          </div>
        </Dialog>
      </WebOnly>
      <WapOnly>
        <Popup open={open} onClose={onClose} height={'70vh'}>
          {renderTitle()}
          <div className="box-dialog-inner">
            <section className={styles.content}>
              <div className={styles.inner}>
                <div className={styles.highlight}>{t('whatsCoveredBySeel')}</div>
                <div className={styles.special}>
                  <div>{t('getFullRefund')}</div>
                  <ul>
                    <li>
                      <Image
                        src="/payment/icon-yes.png"
                        alt=""
                        width={16}
                        height={16}
                        className="w-16 h-16"
                      />{' '}
                      {t('lostInTransit')}
                    </li>
                    <li>
                      <Image
                        src="/payment/icon-yes.png"
                        alt=""
                        width={16}
                        height={16}
                        className="w-16 h-16"
                      />{' '}
                      {t('itemDamagedInTransit')}
                    </li>
                    <li>
                      <Image
                        src="/payment/icon-yes.png"
                        alt=""
                        width={16}
                        height={16}
                        className="w-16 h-16"
                      />{' '}
                      {t('packageStolenOrMissing')}
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.inner}>
                <div className={styles.highlight}>{t('easyResolution')}</div>
                <div className={styles.normalTxt}>{t('resolveIssuesWithFewClicks')}</div>
              </div>
              <div className={styles.inner}>
                <div className={styles.highlight}>{t('completePeaceOfMind')}</div>
                <div className={styles.listTxt}>
                  <ul>
                    <li className={styles.normalTxt}>{t('zeroRiskWithProtection')}</li>
                    <li className={styles.normalTxt}>{t('getRefundPromptly')}</li>
                  </ul>
                </div>
              </div>
            </section>
            <section className={`${styles.btnSection} w-full`}>
              <div className={`${styles.btn} w-full px-24`} onClick={handleConfirm}>
                {t('optInNowForFullProtection')}
              </div>
              <div className={styles.noNeed} onClick={handleCancel}>
                {t('noNeed')}
              </div>
            </section>
            <section className={styles.footer}>
              <a href="https://www.seel.com/privacy" target="_blank" rel="noopener noreferrer">
                {t('privacyPolicy')}
              </a>
              <a
                href="https://www.seel.com/terms/worry-free-delivery-for-customer"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('termsOfService')}
              </a>
            </section>
          </div>
        </Popup>
      </WapOnly>
    </>
  );
}
